import t from '@guestyci/localize/t.macro';

const CHAR_RULE_DEFINITIONS = {
  hasNumber: {
    getLabel: () => t('One number'),
    validate: pw => /\d/.test(pw),
  },
  hasLowercase: {
    getLabel: () => t('One lowercase letter'),
    validate: pw => /[a-z]/.test(pw),
  },
  hasUppercase: {
    getLabel: () => t('One uppercase letter'),
    validate: pw => /[A-Z]/.test(pw),
  },
  hasSymbol: {
    getLabel: () => t('One symbol (e.g., !@#$%^&*)'),
    validate: pw => /[^a-zA-Z0-9\s]/.test(pw),
  },
};

const parseOktaRequirementToken = token => {
  const minLengthMatch = token.match(/^minLength:(\d+)$/);
  if (minLengthMatch) {
    const min = parseInt(minLengthMatch[1], 10);
    return {
      key: 'minLength',
      label: `${min} ${t('characters minimum')}`,
      validate: pw => pw.length >= min,
      alwaysVerifiable: true,
    };
  }

  const charRuleDefinition = CHAR_RULE_DEFINITIONS[token];
  if (charRuleDefinition) {
    return {
      key: token,
      label: charRuleDefinition.getLabel(),
      validate: charRuleDefinition.validate,
      alwaysVerifiable: true,
    };
  }

  return null;
};

export const parseOktaRequirements = tokens =>
  tokens.map(parseOktaRequirementToken).filter(Boolean);

const IDENTITY_KEYS = new Set(['noEmail', 'noFirstName', 'noLastName']);

export const extractOktaRuleMap = tokens => {
  const ruleMap = {};
  for (const token of tokens) {
    const minLengthMatch = token.match(/^minLength:(\d+)$/);
    if (minLengthMatch) {
      ruleMap.minLength = parseInt(minLengthMatch[1], 10);
      continue;
    }
    if (CHAR_RULE_DEFINITIONS[token] || IDENTITY_KEYS.has(token)) {
      ruleMap[token] = true;
    }
  }
  return ruleMap;
};
